import { handleLocalStorage } from 'shared/helpers/handleLocalStorage';
import { setShippingPoint } from 'shared/store/appStore';
import { getShippingPoints } from 'shared/store/settingsStore';

export const isShippingPointSet = async () => {
  const shippingPointName = handleLocalStorage('shippingPointName');
  setShippingPoint(shippingPointName);
  getShippingPoints();
};
